import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';

import './Pagination.css';

const Pagination = ({
  humanPageNumber,
  nextPagePath,
  numberOfPages,
  pageNumber,
  pagesToShow = 2,
  previousPagePath,
}) => {
  const output = [];

  if (!nextPagePath && !previousPagePath) {
    return false;
  }

  const urlPrefix = (nextPagePath || previousPagePath).replace(/\/\d*?$/, ``);

  if (previousPagePath) {
    output.push(
      <li>
        <Link
          className="Pagination__link Pagination__link--previous"
          to={previousPagePath}
        >
          Previous page
        </Link>
      </li>
    );
  }

  for (let i = 0; i < numberOfPages; i++) {
    const page = i + 1;

    if (page === humanPageNumber) {
      output.push(
        <li>
          <span>{page}</span>
        </li>
      );
      continue;
    }

    if (
      page === 1 ||
      (page >= humanPageNumber - pagesToShow &&
        page <= humanPageNumber + pagesToShow) ||
      page === numberOfPages
    ) {
      output.push(
        <li
          className={classnames(`Pagination__wrapper`, {
            'Pagination__wrapper--first': page === 1,
            'Pagination__wrapper--last': page === numberOfPages,
          })}
        >
          <Link to={page === 1 ? urlPrefix : `${urlPrefix}/${page}`}>
            {page}
          </Link>
        </li>
      );
      continue;
    }

    if (
      page === humanPageNumber - pagesToShow - 1 ||
      page === humanPageNumber + pagesToShow + 1
    ) {
      output.push(
        <li>
          <i>…</i>
        </li>
      );
      continue;
    }
  }

  if (nextPagePath) {
    output.push(
      <li>
        <Link
          className="Pagination__link Pagination__link--next"
          to={nextPagePath}
        >
          Next page
        </Link>
      </li>
    );
  }

  return (
    <nav className="Pagination">
      <ul>{output}</ul>
    </nav>
  );
};

export default Pagination;
